import { userType } from "../../../DTO";
import { Api } from "../../api";

export const EditPost = (
    user: userType,
    postId: number,
    title: string,
    context: string,
    attachments: number[],
) => {
    return new Promise<{ data: any }>((resolve, reject) => {
        const api = new Api({
            method: "post",
            path: `peer_group/post/${postId}/edit`,
            header: {
                Authorization: `Bearer ${user.access_token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                title,
                context,
                attachment_ids: attachments,
            }),
        });

        return api
            .call()
            .then((data: any) =>
                resolve({
                    data,
                }),
            )
            .catch((error: any) => reject(error.data.message));
    });
};
